<template>
  <infinite-scroll
    :disabled="disabled"
    @to-bottom="loadMore"
    class="infinite-scroll"
    :class="{'keyword-search': query.name}"
  >
    <transition name="slide-up-down">
      <form
        action="javascript:;"
        class="search-form"
        @submit.prevent="search({name: asyncQuery.name})"
        v-show="showSearch || query.name"
      >
        <div class="search">
          <search-icon class="icon"/>
          <input v-model.trim="asyncQuery.name" type="text" placeholder="搜索">
          <button type="submit" v-show="0"></button>
          <reset-icon @click.native="reset" class="reset-icon"/>
        </div>
      </form>
    </transition>
    <ul class="content-normal">
      <li
        @click="$router.push({name: 'workDetail', query: {id: v.id}})"
        v-for="v of data"
        :key="v.id"
        class="works-items"
      >
        <x-image class="cover" :size="59" el="div" :img-src="v.preview_url"/>
        <div class="content">
          <h5>{{v.name}}</h5>
          <p class="date">{{v.created_at | date('Y-m-d')}}</p>
          <p v-if="!v.is_mark" class="no-start">未评分</p>
          <p v-else class="start">总分：
            <rate
              :value="v.total_score / 100 * 5"
              disabled
              void-color="#e3feff"
              text-color="#ffe600"
            />
          </p>
        </div>
      </li>
    </ul>
    <div class="scroll-tips">
      <p class="no-more" v-show="noMore">没有更多数据了</p>
      <p class="loading" v-show="!noMore">
        <loading box-size="16" round-size="4"/>加载更多...
      </p>
    </div>
  </infinite-scroll>
</template>
<script>
import { Rate } from 'element-ui'
import XImage from '@/components/XImage'
import Loading from '@/components/Loading'
import InfiniteScroll from '@/components/InfiniteScroll'
import SearchIcon from '@/assets/svg/icon_search.svg'
import ResetIcon from '@/assets/svg/icon_reset.svg'
import { get } from '@/utils/ajax'
import mixinSearch from '@/utils/mixin_search'
const defineQuery = {
  name: '',
  limit: 15
}
export default {
  name: 'WorksList',
  components: {
    InfiniteScroll,
    XImage,
    Rate,
    Loading,
    ResetIcon,
    SearchIcon
  },
  mixins: [mixinSearch(defineQuery)],
  created() {
    this.refresh()
  },
  data() {
    return {
      query: Object.assign({}, defineQuery),
      asyncQuery: Object.assign({}, defineQuery),
      data: [],
      page: 1,
      showSearch: false,
      disabled: true,
      noMore: false
    }
  },
  methods: {
    async refresh(type = 'fresh', ext = { page: 1 }) {
      this.disabled = true
      const { items } = await get(
        '/edu/wap/works',
        Object.assign({}, this.$route.query, ext),
        { loading: ext.page === 1 }
      )
      const length = items.length
      if (length && type === 'more') this.data = this.data.concat(items)
      if (type === 'fresh') {
        this.$el.scrollTop = 0
        this.page = 1
        this.data = items
      }
      if (length === 0 || length < this.query.limit) {
        this.noMore = true
      } else {
        this.disabled = false
        this.page++
      }
      // 这是一个hack，用以解决莫名其妙无法滚动的问题，后续呢将重写滑动逻辑
      this.$nextTick(() => {
        this.$el.style.overflowY = 'initial'
        setTimeout(() => {
          this.$el.style.overflowY = 'scroll'
        })
      })
    },
    reset() {
      this.asyncQuery.name = ''
    },
    loadMore() {
      if (this.disabled) return
      this.refresh('more', { page: this.page })
    },
    scrollHanlder(top) {
      if (top > 50) {
        this.showSearch = true
      } else {
        this.showSearch = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.infinite-scroll
  height 100%
.keyword-search
  .search-form
    position initial
.is-web
  .search-form
    top 108px
.search-form
  position fixed
  width 100%
  top 44px
  left 0
  background-color #f4f4f4
  padding 7px 15px
  .search
    border-radius 4px
    display flex
    align-items center
    justify-content space-between
    padding 6px 15px
    background-color white
    input
      flex-grow 1
      padding-left 14px
      padding-right 14px
  .icon
    width 14px
    height 14px
    fill #999
  .reset-icon
    width 14px
    height 14px
.search-form
  z-index 1
.scroll-tips
  margin-top 10px
  min-height 20px
.no-more
  text-align center
.loading
  display flex
  justify-content center
  margin-right 5px
  >>> .spinner
    margin-right 10px
.works-items
  min-height 80px
  padding-top 20px
  padding-bottom 14px
  flex-shrink 0
  display flex
  // border-1('%23f6f6f6', bottom)
  border-bottom 1px solid #f6f6f6
  &:last-child
    border-bottom 0
  h5
    color #333
    margin-bottom 10px
    font-size 16px
  p
    color #999
  .no-start
    margin-bottom 0
    color #feb210
.start
  display flex
  align-items center
  >>> .el-rate
    height initial
  >>> .el-rate__icon
    font-size 12px
    margin-right 1px
.cover
  width 80px
  height 80px
  margin-right 15px
  border-radius 8px
</style>
